<script setup>
useHead({ bodyAttrs: { id: 'public' } })
const { getPoint, getSettings } = useDatabase()
const site = await getSettings('site')
</script>

<template>
  <header>
    <div class="header-wrapper">
      <div class="header-left">
        <NuxtLink to="/" target="_blank">
          <h1 class="inline-flex xl:hidden items-center gap-x-2 font-noto-sans leading-tight text-base sm:text-xl">
            <NuxtImg src="/logo.png" width="50px" />
            {{ site.name }}
          </h1>
        </NuxtLink>
      </div>

      <NuxtLink to="/" target="_blank" class="header-logo">
        <NuxtImg src="/logo.png" class="w-32" />
      </NuxtLink>

      <div class="header-right">
        <NuxtLink to="/login" target="_blank" class="btn btn-primary w-32">ログイン</NuxtLink>
      </div>
    </div>

  </header>

  <slot></slot>

  <footer>
  </footer>
</template>